import { useMutation } from '@tanstack/react-query';
import { UpdateBusinessRequestBody } from 'compliance-api';
import { FormikErrors, FormikValues } from 'formik';
import { api } from '@/modules/common/api/index.ts';
import { queryClient } from '@/modules/common/query.ts';
import { withErrorHandling } from '@/modules/common/utils/error-utils.tsx';
import { COMPLIANCE_CURRENT_USER_QUERY_KEY } from '@/modules/auth/queries/user.tsx';

export const useUpdateBusinessMutation = ({
  setErrors,
  onSuccess,
}: {
  setErrors?: (errors: FormikErrors<FormikValues>) => void;
  onSuccess?: () => void;
} = {}) => {
  return useMutation({
    mutationFn: async ({ id, ...payload }: UpdateBusinessRequestBody & { id: number }) => {
      const response = await withErrorHandling(
        api.v1.updateBusinessV1BusinessIdPatch({ id }, payload),
        {
          loading: 'Loading...',
          success: 'The business was updated successfully.',
          setErrors,
        },
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [COMPLIANCE_CURRENT_USER_QUERY_KEY],
      });
      onSuccess && onSuccess();
    },
  });
};
